import { render, staticRenderFns } from "./ChartRevenu.vue?vue&type=template&id=08580514&scoped=true"
import script from "./ChartRevenu.vue?vue&type=script&lang=js"
export * from "./ChartRevenu.vue?vue&type=script&lang=js"
import style0 from "./ChartRevenu.vue?vue&type=style&index=0&id=08580514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08580514",
  null
  
)

export default component.exports